module.exports = __webpack_public_path__ + "static/hsbc1-0170a6fdc43f82601ed23ec38c1cb09c.png";